import { useState, useEffect } from 'react'
import { AlertTriangle, X } from 'lucide-react'

const FACTION_BALANCE_THRESHOLD = 2

export default function FactionBalanceWarning({ players, factions }) {
  const factionCounts = {}
  factions.forEach(f => { factionCounts[f.id] = { name: f.name, color: f.color, count: 0 } })
  players.forEach(p => {
    if (p.reg_status !== 'approved') return
    if (!p.faction_id) return
    if (factionCounts[p.faction_id]) factionCounts[p.faction_id].count++
  })

  const factionList = Object.values(factionCounts).filter(f => f.count > 0)
  const max = factionList.length >= 2 ? Math.max(...factionList.map(f => f.count)) : 0
  const min = factionList.length >= 2 ? Math.min(...factionList.map(f => f.count)) : 0
  const delta = max - min
  const sorted = [...factionList].sort((a, b) => b.count - a.count)
  const dismissKey = `dc_balance_dismissed:${sorted.map(f => `${f.name}:${f.count}`).join('|')}`

  const [dismissed, setDismissed] = useState(() => localStorage.getItem(dismissKey) === '1')

  // Re-sync dismissed state whenever the balance changes (different dismissKey)
  useEffect(() => {
    setDismissed(localStorage.getItem(dismissKey) === '1')
  }, [dismissKey])

  if (factionList.length < 2 || delta < FACTION_BALANCE_THRESHOLD || dismissed) return null

  const handleDismiss = () => {
    localStorage.setItem(dismissKey, '1')
    setDismissed(true)
  }

  return (
    <div style={{
      background: 'rgba(255, 204, 51, .06)',
      border: '1px solid rgba(255, 204, 51, .25)',
      padding: '12px 16px',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      fontFamily: "'JetBrains Mono', monospace",
      position: 'relative',
    }}>
      <div style={{ position:'absolute',top:-1,left:-1,width:6,height:6,borderTop:'2px solid #ffcc33',borderLeft:'2px solid #ffcc33' }}/>
      <div style={{ position:'absolute',bottom:-1,right:-1,width:6,height:6,borderBottom:'2px solid #ffcc33',borderRight:'2px solid #ffcc33' }}/>

      <AlertTriangle size={18} style={{ color: '#ffcc33', flexShrink: 0, marginTop: 2 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ color: '#ffcc33', fontWeight: 600, fontSize: '12px', letterSpacing: '0.08em', textTransform: 'uppercase', fontFamily: "'VT323', monospace" }}>
          FACTION BALANCE WARNING
        </p>
        <p style={{ color: 'rgba(255,204,51,.7)', fontSize: '11px', marginTop: '4px' }}>
          Delta: {delta}.{' '}
          {sorted.map((f, i) => (
            <span key={f.name}>
              <strong style={{ color: f.color }}>{f.name}</strong>: {f.count}
              {i < sorted.length - 1 && ' · '}
            </span>
          ))}
        </p>
      </div>
      <button
        onClick={handleDismiss}
        title="Dismiss until teams change"
        style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(255,204,51,.5)', padding: 2, display: 'flex', alignItems: 'center', flexShrink: 0 }}
      >
        <X size={14} />
      </button>
    </div>
  )
}
